
import Vue from 'vue';
import { mapState, mapGetters, mapActions } from 'vuex';

import { ProfileActions } from '@/store/modules/user/profile/types';
import { ClinicalTrainingEventsActions } from '@/store/modules/clinical-training-events/types';

export default Vue.extend({
  data() {
    return {
      bannerStyle: {
        width: '100%',
        padding: '10px 20px',
        background: 'black',
        color: 'white',
        marginBottom: '10px',
        borderRadius: '4px',
      },
    };
  },
  computed: {
    ...mapState('user/profile', {
      currentUser: 'currentProfile',
    }),
    ...mapGetters('user/profile', ['isInNorthAmerica', 'isInCA', 'isLoaded']),
    ...mapState('clinicalTrainingEvents', {
      events: 'list',
    }),
    shouldShowBanner(): boolean {
      return (this.isInNorthAmerica || this.isInCA) && this.events && this.events.length > 0;
    },
  },
  methods: {
    ...mapActions('user/profile', {
      openClinicalEventsModal: ProfileActions.OPEN_CLINICAL_EVENTS_MODAL,
    }),
    ...mapActions('clinicalTrainingEvents', {
      loadEvents: ClinicalTrainingEventsActions.LOAD_ACTIVE,
    }),
    hasOwnedProduct(ampsId) {
      return this.currentUser.products.some(product => product.owned && product.id === ampsId);
    },
  },
  mounted() {
    if (this.isLoaded) {
      this.loadEvents();
    }
  },
});
